import React from 'react';
import { Briefcase, GraduationCap } from 'lucide-react';
import PathTimelineItem from './PathTimelineItem';
import { educationPath } from '../data/education';
import { experiences, pickLocalizedField } from '../data/experiences';
import { useLocale } from '../context/LocaleContext';

const EducationTimeline = () => {
  const { lang } = useLocale();

  return (
    <ol className="path-timeline path-timeline--stack" data-reveal-stagger>
      {educationPath.map((entry) => (
        <PathTimelineItem
          key={entry.id}
          icon={GraduationCap}
          variant="education"
          title={pickLocalizedField(entry, lang, 'title')}
          subtitle={entry.school}
          period={entry.period}
        />
      ))}
    </ol>
  );
};

const ExperienceTimeline = () => {
  const { lang } = useLocale();

  return (
    <ol className="path-timeline path-timeline--grid" data-reveal-stagger>
      {experiences.map((experience) => {
        const position = pickLocalizedField(experience, lang, 'position');
        const period = pickLocalizedField(experience, lang, 'period');
        const location = pickLocalizedField(experience, lang, 'location');
        const description = pickLocalizedField(experience, lang, 'description');

        return (
          <PathTimelineItem
            key={experience.id}
            icon={Briefcase}
            variant="experience"
            title={experience.company}
            subtitle={position}
            period={period}
            location={location}
            details={description}
          />
        );
      })}
    </ol>
  );
};

export { EducationTimeline, ExperienceTimeline };
